import { render, staticRenderFns } from "./humanNuclear.vue?vue&type=template&id=23f6e866&scoped=true"
import script from "./humanNuclear.vue?vue&type=script&lang=js"
export * from "./humanNuclear.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f6e866",
  null
  
)

export default component.exports